import {ApiContent} from '../../../application/contentLoaders/apiContent';
import {formatShopLogo} from '../../../application/shopLogo';

class SearchContent extends ApiContent {
    /**
     * @param {string} endpoint
     * @param {string} searchQuery
     * @param {CallableFunction} loadedCallback
     */
    constructor(endpoint, searchQuery, loadedCallback) {
        super(endpoint, {query: searchQuery}, loadedCallback);
    }

    /**
     * @param {string} result.url
     * @param {string} result.name
     * @param {string} result.alias
     * @param {string} result.image
     * @param {Object} result
     * @returns {string}
     */
    formatResultTemplate(result) {
        let logo = formatShopLogo({
            src: result.image,
            name: result.shop_logo_name,
            placeholder: result.shop_logo_placeholder,
            width: 124,
            height: 88,
            size: 'medium',
            alt: result.name,
        });

        return `<div class="brands-item">
            <a href="${result.url}" class="brands-item-img">
                ${logo}
            </a>
            <div class="brands-item-name">
                <a href="${result.url}">${result.alias}</a>
            </div>
        </div>`;
    }
}

export {SearchContent};
